import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "../locales/en/common.json";
import enSeo from "../locales/en/seo.json";
import es from "../locales/es/common.json";
import esSeo from "../locales/es/seo.json";

export const LANG_STORAGE_KEY = "lang";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { common: es, seo: esSeo },
      en: { common: en, seo: enSeo },
    },
    fallbackLng: "es",
    defaultNS: "common",
    ns: ["common", "seo"],
    supportedLngs: ["es", "en"],
    interpolation: { escapeValue: false },
    detection: {
      // VoltaRoute serves Colombia first; first-time visitors land in
      // Spanish regardless of browser locale. Navigator is intentionally
      // omitted so fallbackLng wins when nothing is stored.
      order: ["localStorage"],
      lookupLocalStorage: LANG_STORAGE_KEY,
      caches: [],
    },
    returnNull: false,
  })
  .catch((err) => console.error("[i18n] init failed", err));

export default i18n;
